import { render, staticRenderFns } from "./ChildrenAction.vue?vue&type=template&id=5621c8b5&scoped=true&"
import script from "./ChildrenAction.vue?vue&type=script&lang=js&"
export * from "./ChildrenAction.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenAction.vue?vue&type=style&index=0&id=5621c8b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621c8b5",
  null
  
)

export default component.exports